const featureNames = Object.freeze({
  ACQUISITION_BOOSTER: 'acquisition-booster',
  AD_MATERIALS: 'ad-materials',
  AI_SETTINGS: 'ai-settings',
  APP_BRANDING: 'app-branding',
  ASSIGN_LEADS: 'assign-leads',
  AUTHORIZATION: 'authorization',
  AVV: 'avv',
  BILLWERK: 'billwerk',
  WEBSITE_SCRAPE: 'website-scrape',
  CAMPAIGN: 'campaign',
  CHANGE_SUBSCRIPTION: 'change-subscription',
  CMS: 'cms',
  COMPANY_USER: 'company-user',
  COMPANY: 'company',
  CONSULTING: 'consulting',
  CONTACTS: 'contacts',
  CONTENT_CREATOR: 'content-creator',
  CONTRACT: 'contract',
  CRM: 'crm',
  DASHBOARD_PRESENTATION: 'dashboard-presentation',
  DATA_PRIVACY: 'data-privacy',
  DELETE_CONTACT: 'delete-contact',
  DELETE_LEADS: 'delete-leads',
  EVENT_CALENDAR: 'event-calendar',
  FEEDBACK_TICKET: 'feedback-ticket',
  HELPCENTER: 'helpcenter',
  HOPPERMATION: 'hoppermation',
  I18N: 'i18n',
  IUBENDA: 'iubenda',
  LANDINGPAGE_NAVIGATION: 'landingpage-navigation',
  LANDINGPAGE: 'landingpage',
  LEAD_EXPORT: 'lead-export',
  LEAD_IMPORT: 'lead-import',
  LEAD: 'lead',
  LICENSE_AGREEMENT: 'license-agreement',
  MATERIAL_GUIDE: 'material-guide',
  NEWSFLASH: 'newsflash',
  NOTIFICATIONS: 'notifications',
  ONBOARDING_PREVIEW: 'onboarding-preview',
  PARTNER: 'partner',
  PERFORMANCE_MARKETING: 'performance-marketing',
  PLOT_VALUATION: 'lp-grundstuecksbewertung',
  POSTAL_SHIPPING: 'postal-shipping',
  PRODUCTFRUITS: 'productfruits',
  REGENERATION: 'regeneration',
  REGISTER: 'register',
  RETURNCALL_TOPICS: 'returncall-topics',
  SIGNUP: 'signup',
  SSO: 'sso',
  STATIC_CAMPAIGN: 'static-campaign',
  STATISTIC_DASHBOARD: 'statistic-dashboard',
  SUPPORT_CONTACT: 'support-contact',
  TEXT_AI_TOPICS: 'text-ai-topics',
  TOPIC: 'topic',
  TOPIC_SETTINGS: 'topic-settings',
  USAGE_COUNTER: 'usage-counter',
  VALUATION: 'valuation',
  ZOHO_CHAT: 'zoho-chat',
})

export default featureNames
